import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

export default function BalanceSheet() {
  const { apiFetch } = useAuth();
  const [report, setReport] = useState(null);

  useEffect(() => {
    apiFetch('/api/reports/balance-sheet').then(setReport).catch(() => {});
  }, []);

  const fmt = (n) => new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(n);

  const downloadPdf = async () => {
    const token = localStorage.getItem('token');
    const API_BASE = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001';
    const res = await fetch(`${API_BASE}/api/reports/balance-sheet/pdf`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) return;
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Balance-${report?.fiscal_year?.name || ''}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  if (!report) return <div className="loading">Indlæser...</div>;

  const renderSection = (title, items, total, totalLabel) => (
    <div className="report-section">
      <h3>{title}</h3>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Konto</th>
              <th>Navn</th>
              <th className="text-right">Saldo</th>
            </tr>
          </thead>
          <tbody>
            {items.map(a => (
              <tr key={a.id}>
                <td>{a.account_number}</td>
                <td>{a.name}</td>
                <td className="text-right amount">{fmt(a.balance)}</td>
              </tr>
            ))}
            <tr className="report-total">
              <td colSpan="2"><strong>{totalLabel}</strong></td>
              <td className="text-right amount"><strong>{fmt(total)}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );

  const equityTotal = report.equity.reduce((s, a) => s + a.balance, 0);

  return (
    <div>
      <div className="page-header">
        <h1>Balance</h1>
        <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
          {report.fiscal_year && (
            <span style={{color: 'var(--gray-500)'}}>
              {report.fiscal_year.name} ({new Date(report.fiscal_year.start_date).toLocaleDateString('da-DK')} - {new Date(report.fiscal_year.end_date).toLocaleDateString('da-DK')})
            </span>
          )}
          <button className="btn btn-secondary" onClick={downloadPdf}>Download PDF</button>
        </div>
      </div>

      {renderSection('Aktiver', report.assets, report.total_assets, 'Aktiver i alt')}
      {renderSection('G\u00e6ld', report.liabilities,
        report.liabilities.reduce((s, a) => s + a.balance, 0), 'G\u00e6ld i alt')}

      <div className="report-section">
        <h3>Egenkapital</h3>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Konto</th>
                <th>Navn</th>
                <th className="text-right">Saldo</th>
              </tr>
            </thead>
            <tbody>
              {report.equity.map(a => (
                <tr key={a.id}>
                  <td>{a.account_number}</td>
                  <td>{a.name}</td>
                  <td className="text-right amount">{fmt(a.balance)}</td>
                </tr>
              ))}
              {report.net_result !== 0 && (
                <tr style={{fontStyle: 'italic'}}>
                  <td></td>
                  <td>{'\u00c5'}rets resultat</td>
                  <td className="text-right amount">{fmt(report.net_result)}</td>
                </tr>
              )}
              <tr className="report-total">
                <td colSpan="2"><strong>Egenkapital i alt</strong></td>
                <td className="text-right amount"><strong>{fmt(equityTotal + report.net_result)}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="report-result">
        Passiver i alt: {fmt(report.total_liabilities_and_equity)}
      </div>
    </div>
  );
}
